import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";

// import img1 from "../../img/city-transport.png";
import img1 from "../../img/serviceicon.png";
// import img2 from "../../img/airport-transport.png";
import img2 from "../../img/serviceicon.png";
// import img3 from "../../img/hospital-transport.png";
import img3 from "../../img/serviceicon.png";
import img4 from "../../img/serviceicon.png";
// import img4 from "../../img/wedding-ceremony.png";
import img5 from "../../img/serviceicon.png";
// import img6 from "../../img/luggege-transport.png";
import img6 from "../../img/serviceicon.png";

import "./style.css";

const ServiceList = () => {
  const { t } = useTranslation();

  return (
    <section className="gauto-service-area service-page-area section_70">
      <Container>
        <Row>
          <Col md={12}>
            <div className="site-heading">
              <h4>{t("see_our")}</h4>
              <h2>{t("latest_service")}</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className="single-service">
              <span className="service-number">01 </span>
              <div className="service-icon">
                <img src={img1} alt="city trasport" />
              </div>
              <div className="service-text">
                <Link to="/service-single">
                    <h3>Airport Transfers</h3>
                </Link>
                <p>
                Enjoy punctual, stress-free transfers to and from JRO and Arusha Airport in luxury and style.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single-service">
              <span className="service-number">02 </span>
              <div className="service-icon">
                <img src={img2} alt="airport trasport" />
              </div>
              <div className="service-text">
                <Link to="/service-single">
                     <h3>Private Charter Transfers</h3>
                </Link>
                <p>
                   Flexible, private transport solutions tailored to your safari, lodge, or executive travel needs.
          
                </p>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single-service">
              <span className="service-number">03 </span>
              <div className="service-icon">
                <img src={img3} alt="hospital trasport" />
              </div>
              <div className="service-text">
                <Link to="/service-single">
                   <h3>Corporate Transfers</h3>
                </Link>
                <p>
                  Reliable executive transport designed for business guests who value comfort, safety, and professionalism.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single-service">
              <span className="service-number">04 </span>
              <div className="service-icon">
                <img src={img4} alt="wedding trasport" />
              </div>
              <div className="service-text">
                <Link to="/service-single">
                  <h3>Luxury Event Transport</h3>
                </Link>
                <p>
                  Arrive with confidence and elegance at weddings, conferences, and exclusive events across Tanzania.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single-service">
              <span className="service-number">05 </span>
              <div className="service-icon">
                <img src={img5} alt="wedding trasport" />
              </div>
              <div className="service-text">
                <Link to="/service-single">
                  <h3>Arusha City Tours</h3>
                </Link>
                <p>
                  Explore Arusha’s culture and landmarks in refined comfort with our premium safari vehicles and professional drivers.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single-service">
              <span className="service-number">06 </span>
              <div className="service-icon">
                <img src={img6} alt="wedding trasport" />
              </div>
              <div className="service-text">
                <Link to="/service-single">
                  <h3> Safari Equipment Transport</h3>
                </Link>
                <p>
                  Transport your safari gear safely and efficiently with our specialized vehicles and experienced drivers.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ServiceList;
